/**
 * Evidence of one product assessment, kept in the triage (DEV-100): files that
 * back the verdict of this version. The Security Advisory is written once per
 * product in its vulnerability case (DEV-134).
 */
import { Trans } from '@lingui/react/macro';
import { useEffect, type ReactNode } from 'react';

import Banner from '../../components/Banner';
import Spinner from '../../components/Spinner';

import { AttachmentsPanel } from './TriageDocumentPanels';
import { useTriageDocuments } from './useTriageDocuments';

export function ProductDocuments({ versionId, cve, canWrite, onDirtyChange }: Readonly<{
  versionId: number;
  cve: string;
  canWrite: boolean;
  onDirtyChange: (dirty: boolean) => void;
}>): ReactNode {
  const documents = useTriageDocuments({ versionId, cve });
  const unsaved = canWrite && documents.queue.length > 0;

  useEffect(() => onDirtyChange(unsaved), [unsaved, onDirtyChange]);
  // Leaving the version drops its pending uploads with the component.
  useEffect(() => () => onDirtyChange(false), [onDirtyChange]);

  if (documents.loading) return <p role="status"><Spinner /> <Trans>Nachweise werden geladen…</Trans></p>;
  const { loadError } = documents;
  return (
    <div className="assessment-documents">
      {loadError ? <Banner kind="error"><Trans>Nachweise konnten nicht geladen werden: {loadError}</Trans></Banner> : null}
      {documents.error ? <Banner kind="error">{documents.error}</Banner> : null}
      {documents.documents ? (
        <AttachmentsPanel state={documents} disabled={documents.busy} canWrite={canWrite} />
      ) : null}
    </div>
  );
}

export default ProductDocuments;
